import * as Types from '../../types';
import * as StoreTypes from '../../store/types';

export const parse = (response: Types.ILoginHistoryDataResponse): StoreTypes.IUpdateHistoryPayload => {
    const { pagingParams: { totalCount, nextPageId }, playerLogins } = response;
    const history = playerLogins.map((item: Types.ILoginHistoryItem) => ({
        clientType: item.clientType,
        clientPlatform: item.clientPlatform,
        loginDate: item.loginDate,
        logoutDate: item.logoutDate,
        ipAddress: item.ipAddress
    }));

    return {
        ...totalCount && { totalCount },
        history,
        ...nextPageId && { nextPageId: Number(nextPageId) }
    };
};
